import React from 'react';
import './App.css';
import { ImageComposer } from './components/ImageComposer';

function App() {
  return (
    <div className="App">
      <ImageComposer />
    </div>
  );
}

export default App;
